const data = [
  { id: 1, name: "MANHÃ" },
  { id: 2, name: "TARDE" },
  { id: 3, name: "NOITE" },
];
  
export default [...data];
  